import type { AnyFieldApi } from "@tanstack/react-form";

import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils/cn";

interface SelectFieldProps {
  field: AnyFieldApi;
  label: string;
  options: { value: string; label: string }[];
  className?: string;
}

/**
 * Native <select> bound to a TanStack Form field. A native control (rather than
 * a Radix Select, which isn't in the shared ui kit) keeps the slice dependency
 * free while staying keyboard- and screen-reader-accessible.
 */
export function SelectField({ field, label, options, className }: SelectFieldProps) {
  return (
    <div className={cn("space-y-1.5", className)}>
      <Label htmlFor={field.name}>{label}</Label>
      <select
        id={field.name}
        name={field.name}
        value={(field.state.value as string | undefined) ?? ""}
        onChange={(e) => field.handleChange(e.target.value)}
        onBlur={field.handleBlur}
        className={cn(
          "flex min-h-touch w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        )}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </div>
  );
}
